import {useCallback, useState} from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import ApiBooking from "../types/ApiBooking";
import {useOidcClientContext} from "../../ui/context/OidcClientContext";
import useCustomerContext from "../../customers/hooks/useCustomerContext";
import {ME_BASE_URL} from "../../../config/config";

type Output = ApiBooking[];

export interface BookingFilters {
    confirmationNo?: string;
    event?: string;
    city?: string;
    hotel?: string;
    confirmed?: boolean;
    canceled?: boolean;
    pending?: boolean;
    paid?: boolean;
    refunded?: boolean;
    arrivalDate?: {
        after?: Date,
    },
    departureDate?: {
        before?: Date,
    }
}

export function useBookingMeSearchData() {
    const {client: oidcClient} = useOidcClientContext();
    const {languageCode} = useCustomerContext();
    const client = useAPIClient(ME_BASE_URL);

    client.onError(error => {
        if (error.statusCode === 401) {
            oidcClient.login({
                locale: languageCode,
            }).then();
        } else {
            throw error;
        }
    });

    const [data, setData] = useState<Output>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback((filters: BookingFilters) => {
        setLoading(true);

        return client.get<Output>(`bookings`, {
            id: filters.confirmationNo,
            event: filters.event,
            city: filters.city,
            hotel: filters.hotel,
            confirmed: filters.confirmed,
            canceled: filters.canceled,
            pending: filters.pending,
            paid: filters.paid,
            refunded: filters.refunded,
            "bookingHotel.bookingHotelRooms.arrivalDate[after]": filters.arrivalDate?.after,
            "bookingHotel.bookingHotelRooms.departureDate[before]": filters.departureDate?.before,
            itemsPerPage: 1000,
            "order[id]": "DESC",
        }).then((data) => {
            setData(data);
            setLoading(false);
        }).catch(() => {
            setData([]);
            setLoading(false);
        });
    }, [client])

    return {data, loading, fetchData};
}
